// @flow
import React from "react";
import classNames from "classnames";
import {
  LOGGED_OUT_WARNING_NOTIFICATION,
  SIGNED_OUT_SUCCESSFULLY_NOTIFICATION,
  INCORRECT_CREDENTIALS_NOTIFICATION,
  SERVER_ERROR_NOTIFICATION,
  PASSWORD_EXPIRED_NOTIFICATION,
  NO_NOTIFICATION
} from "../redux/actionTypes";

const notficationTypeToMessage = notification => {
  switch (notification) {
    case LOGGED_OUT_WARNING_NOTIFICATION:
      return (
        <span>
          You have been logged out of Localytics. Please sign in below, or&nbsp;
          <a href="https://dashboard.localytics.com/accounts/password/new">
            reset your password
          </a>.
        </span>
      );
    case SIGNED_OUT_SUCCESSFULLY_NOTIFICATION:
      return <span>Signed out successfully.</span>;
    case INCORRECT_CREDENTIALS_NOTIFICATION:
      return <span>Invalid email or password.</span>;
    case PASSWORD_EXPIRED_NOTIFICATION:
      return <span>Password expired, reset instructions have been sent to your email.</span>;
    case SERVER_ERROR_NOTIFICATION:
      return <span>Server error.</span>;
    case NO_NOTIFICATION:
    default:
      return null;
  }
};

const alertNotificationTypes = [
  LOGGED_OUT_WARNING_NOTIFICATION,
  INCORRECT_CREDENTIALS_NOTIFICATION,
  PASSWORD_EXPIRED_NOTIFICATION,
  SERVER_ERROR_NOTIFICATION
];

const successNotificationTypes = [SIGNED_OUT_SUCCESSFULLY_NOTIFICATION];

type Props = {
  notification: string
};

export default function NotificationBanner(props: Props) {
  const { notification } = props;
  const display = notification !== NO_NOTIFICATION;
  const className = classNames("NotificationContainer", {
    AlertNotification: alertNotificationTypes.includes(notification),
    SuccessNotification: successNotificationTypes.includes(notification)
  });
  return (
    <div className={className} style={{ display: display ? "block" : "none" }}>
      {notficationTypeToMessage(notification)}
    </div>
  );
}
